import { QueryClient } from "react-query";

export function handleEmailSent(queryClient: QueryClient) {
    queryClient.invalidateQueries(["getConversationFeedForEntity"]);
}
